// extracted by mini-css-extract-plugin
export var attribution = "_c9-4";
export var authorName = "_c9-5";
export var quote = "_c9-3";
export var testimonial = "_c9-2";
export var trustedBy = "_c9-0";
export var trustedByLabel = "_c9-1";